import { gql } from "apollo-boost";
import { fragments } from "./User";

export default gql`
  query UsersListQuery {
    users {
      ...UsersListUser
    }
  }
  ${fragments.user}
`;



// WEBPACK FOOTER //
// ./src/queries/UsersList.js